/**
 * Subscription tier configuration — frontend mirror of backend/subscriptions/config.py
 *
 * Edit this file (or the backend config) to change plan limits and prices.
 * Both files must stay in sync; the backend is authoritative for enforcement.
 *
 * TIER_LIMITS keys:
 *   max_profiles      number | null  max company profiles per account (null = unlimited)
 *   max_users         number | null  max team members per account (null = unlimited)
 *   max_matches       number | null  max matches shown (null = unlimited)
 *   daily_match_limit number | null  max matches shown per day on dashboard (null = unlimited)
 *   matches_refresh   bool           whether matches update daily
 *   max_countries     number | null  countries user can track (null = all EU)
 *   email_alerts      bool
 *   api_access        bool
 *   sales_portal_api  bool
 */

export const TIER_LIMITS = {
  trial: {
    max_profiles:      1,
    max_users:         1,
    max_matches:       null,
    daily_match_limit: null,
    matches_refresh:   true,
    max_countries:     1,
    email_alerts:      false,
    api_access:        false,
    sales_portal_api:  false,
    csv_export:        false,
  },
  free: {
    max_profiles:      1,
    max_users:         1,
    max_matches:       null,  // unlimited
    daily_match_limit: null,  // unlimited
    matches_refresh:   false,
    max_countries:     1,
    email_alerts:      false,
    api_access:        false,
    sales_portal_api:  false,
    csv_export:        false,
  },
  tier1: {
    max_profiles:      1,
    max_users:         1,
    max_matches:       null,  // unlimited
    daily_match_limit: null,  // unlimited
    matches_refresh:   true,
    max_countries:     1,
    email_alerts:      true,
    api_access:        false,
    sales_portal_api:  false,
    csv_export:        false,
  },
  tier2: {
    max_profiles:      3,
    max_users:         1,
    max_matches:       null,  // unlimited
    daily_match_limit: null,
    matches_refresh:   true,
    max_countries:     null,  // all EU
    email_alerts:      true,
    api_access:        true,
    sales_portal_api:  true,
    csv_export:        false,
  },
  tier3: {
    max_profiles:      10,
    max_users:         1,
    max_matches:       null,  // unlimited
    daily_match_limit: null,
    matches_refresh:   true,
    max_countries:     null,  // all EU
    email_alerts:      true,
    api_access:        true,
    sales_portal_api:  true,
    csv_export:        true,
  },
};

export const TIER_META = {
  trial: { label: 'Trial',        price_eur: 0,  period: '14 days' },
  free:  { label: 'Free trial',   price_eur: 0,  period: '14 days' },
  tier1: { label: 'Starter',      price_eur: 19, period: 'per month' },
  tier2: { label: 'Professional', price_eur: 44, period: 'per month' },
  tier3: { label: 'Scale',        price_eur: 69, period: 'per month' },
};

/** Returns the limits for a given tier key, falling back to 'free'. */
export function getLimits(tier) {
  return TIER_LIMITS[tier] || TIER_LIMITS.free;
}

/** Returns true if subscription_status represents an active paid subscription. */
export function isPaid(subscriptionStatus) {
  return subscriptionStatus === 'active' || subscriptionStatus === 'trialing';
}
